import { ISetCheckValueResponse } from "../../endpoints/common/response.types";
import { PutMethod } from "../../methods/PutMethod";

export class CheckSetValueEndpoint extends PutMethod<ISetCheckValueResponse> {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}/checklists/groups/checks/value`);
  }
}
